(ns ballot-scout-v2-frontend.components.export
  (:require [ballot-scout-v2-frontend.components.click-outside :refer [click-outside]]
            [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
            [reagent.core :as r]))

;; MIMEtypes to specify what file format we want our export file to take.
(def csv-mimetype "text/csv")
(def xlsx-mimetype "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")

#_:clj-kondo/ignore
(defn export-menu [{:keys [on-click button-text align-right? disabled icon-el]}]
  (let [show-export-options (r/atom false)]
    (fn [{:keys [on-click button-text align-right? disabled icon-el]}]
      [click-outside
       {:on-click-outside (fn [_] (reset! show-export-options false))}
       (fn [ref]
         [:div.export-menu {:ref ref
                            :class (when align-right?
                                     "is-pulled-right has-text-right")}
          [:button {:class "button is-secondary"
                    :disabled disabled
                    :on-click #(swap! show-export-options not)}
           button-text
           [:div.p-left-10 (or icon-el [icon ::icon/chevron-down])]]
          (when @show-export-options
            [:div.export-options
             [:div {:class "export-option is-clickable p-2"
                    :on-click #(do (on-click csv-mimetype)
                                   (reset! show-export-options false))}
              "Comma-separated values (.csv)"]
             [:div {:class "export-option is-clickable p-2"
                    :on-click #(do (on-click xlsx-mimetype)
                                   (reset! show-export-options false))}
              "Microsoft Excel (.xlsx)"]])])])))
